import { ProductDetailThemeModeConfig } from './types';

const dark: ProductDetailThemeModeConfig = {
  productDetail: {
    backgroundColor: '#eeeeee88',
    backgroundGradient: 'linear-gradient(to bottom, #eeeeeeee, #ffffffff)',
    cardBackgroundGradient: 'linear-gradient(to bottom, #1a1a1a88, #00000044)',
    hoverBackgroundGradient: 'linear-gradient(to bottom,rgb(34, 34, 34), #00000099)',
    borderColor: ' #333333 ',
    boxShadow: '0 8px 12px 0 #4d4d4d, 0 8px 12px #1a1a1a, 8px 10px 12px 0 #1a1a1a',
    textColor: ' #ffffff',
    labelBGColor: ' #50525a ',
    normalButtonBGColor: ' #505251 ',
    normalButtonBorderColor: '2px solid #267DAC',
  },
};

export default dark;
